// Put your applicaiton javascript here
(function(){
  var animEnd = 'webkitAnimationEnd mozAnimationEnd animationend',
      home = $('#home_content');

  function onSwayEnd(event){
    $(event.currentTarget).removeClass('sway');
  }

  $(document).on('mouseover touchstart', '.threads-img, .swag-img', function(event){
    $(event.currentTarget).addClass('sway').one(animEnd, onSwayEnd);
  });

  function rand(max){
    return Math.floor(Math.random() * Math.floor(max))
  }

  function glitch(){
    var items = home.find('span:not(.text-bungee)');
    if ( home.find('.glitching').length ){
      home.find('.glitching').removeClass('glitching');
      setTimeout(glitch, rand(10000));
      return;
    }

    items.addClass('glitching');
    setTimeout(glitch, rand(1500));
  }

  home.find('span').each(function(i, el){
    $(el).attr('data-text', $(el).text());
  });

  setTimeout(glitch, rand(5000));

  function boxes(node){
    node.find('span.box-letter').each(function(i, el){
        setTimeout(function(){
            $(el).addClass('box-active');
        }, (i * 10));
        
    });
}

$('[data-boxes]').each(function(i, el){
    var node = $(el),
        letters = node.text().split(""),
        result  = $("<span class='box-wrap'></span>");
    letters.forEach(function(l){
        var size  = Math.floor(Math.random() * 80) + 72,
            top   = Math.floor(Math.random() * 16) + 8,
            color = node.css('color'),
            deg   = Math.floor(Math.random() * 1) + 2;
        if( size < 100 ) size = 105;
        deg *= Math.floor(Math.random()*2) == 1 ? 1 : -1;
        result.append("<span class='box-letter' style='--box-color:"+color+"; --box-height:"+size+"%; --box-offset-top:-"+top+"px; --box-rotate:"+deg+"deg'>"+l+"</span>");
    });

    node.html(result);
    boxes(node);
});

$(document).on('ui:update', function(event){
  $('a.art-image:not(.has-zoom)').each(function(i, el){
    $(el).addClass('has-zoom').zoom({ url: $(el).data('image') });
  });
})

jQuery(function(){
  $(document).trigger('ui:update');
});

var contact = $('#footer #contact_form');

function contactSuccess(){
  console.log(arguments);
  $('#contact_form_wrap').addClass('success');
  $('#signup_response').html("<span class='text-secondary h4 text-danger'>Success!</span>")
}

contact.on('submit', function(event){
  event.preventDefault();
  if( contact.get(0).checkValidity() === false ) return false;
  $.ajax({
    type: "POST",
    url: contact.attr('action'),
    data: contact.serialize(),
    success: contactSuccess,
    error: function(){
      console.log(arguments);
    }
  });
});
  
})();